module.exports = __webpack_public_path__ + "static/media/photo14.9c559196.png";